var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83329 17.5H14.1666C15.0871 17.5 15.8333 16.7538 15.8333 15.8333V7.84518C15.8333 7.62416 15.7455 7.4122 15.5892 7.25592L11.0774 2.74408C10.9211 2.5878 10.7091 2.5 10.4881 2.5H5.83329C4.91282 2.5 4.16663 3.24619 4.16663 4.16667V15.8333C4.16663 16.7538 4.91282 17.5 5.83329 17.5Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocs);
export default __webpack_public_path__ + "static/media/docs.b896fb1c9b5f7d480af3c7ef9db97101.svg";
export { ForwardRef as ReactComponent };